import { httpRequest } from "@services/http"

/**
 * Move a legacy campaign onto spend windows, once (MPN-1803).
 *
 * POST with no body. The server lays an Even window over the days that have NOT yet spent
 * and decides the dollars itself — a client that could name the windows could lay the
 * campaign's remaining money back over days that are already gone, which is the thing the
 * command exists to prevent.
 *
 * Not idempotent by design: a second call is refused rather than re-seeding over whatever
 * the operator has since edited.
 */
export class CommandMigrateLaunchBudget {
  async run(launchId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/budget/migrate/`
    await httpRequest(url, { method: "POST" })
  }
}
